module.exports = __webpack_public_path__ + "static/media/pic1.36c3b65c.jpg";